import Content from '../content-interface'
import ContractCanceledRuleHistory from './contract-canceled-rules-history.entity';

export default class ContractCanceledHistory implements Content {
  observation: string;

  rules: ContractCanceledRuleHistory[]

  constructor(obj: any = {}) {
    this.observation = obj.observation || '';
    this.rules = ContractCanceledRuleHistory.ofList(obj.rules) || [];
  }

  public static of(obj: any = {}): ContractCanceledHistory {
    return new ContractCanceledHistory(obj);
  }
}
